import fluidGridColumns from '../../theme/fluidGridColumns';
import { GridItemProps } from '../Grid';

export const splitInfoAccordionCardGridItemProps: GridItemProps = {
  desktop: 10,
  tabletLandscape: 10,
  tabletPortrait: 6,
  mobile: fluidGridColumns.mobile,
};

export const splitInfoCardGridItemProps: GridItemProps = {
  desktop: 10,
  tabletLandscape: 10,
  tabletPortrait: fluidGridColumns.tabletPortrait,
  mobile: fluidGridColumns.mobile,
};

export const evenlySplitInfoCardGridItemProps: GridItemProps = {
  desktop: 8,
  tabletLandscape: 8,
  tabletPortrait: fluidGridColumns.tabletPortrait,
  mobile: fluidGridColumns.mobile,
};

export const phoneInfoGridItemProps: GridItemProps = {
  desktop: 6,
  tabletLandscape: 6,
};

export const openingHoursGridItemProps: GridItemProps = {
  desktop: 4,
  tabletLandscape: 4,
};
